// extracted by css-extract-rspack-plugin
export default {"tooltipWrapper":"src-components-Tooltip-module__tooltipWrapper-jww8aF","tooltip":"src-components-Tooltip-module__tooltip-hqukFz","tooltipFadeIn":"src-components-Tooltip-module__tooltipFadeIn-c8ZJvP","top":"src-components-Tooltip-module__top-rS4eIZ","bottom":"src-components-Tooltip-module__bottom-NEBNOx","left":"src-components-Tooltip-module__left-qDQzeN","right":"src-components-Tooltip-module__right-VWNmZB"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"tooltipWrapper\":\"src-components-Tooltip-module__tooltipWrapper-jww8aF\",\"tooltip\":\"src-components-Tooltip-module__tooltip-hqukFz\",\"tooltipFadeIn\":\"src-components-Tooltip-module__tooltipFadeIn-c8ZJvP\",\"top\":\"src-components-Tooltip-module__top-rS4eIZ\",\"bottom\":\"src-components-Tooltip-module__bottom-NEBNOx\",\"left\":\"src-components-Tooltip-module__left-qDQzeN\",\"right\":\"src-components-Tooltip-module__right-VWNmZB\"}";
        // 1793732290113
        var cssReload = require("../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  